import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SystemUser, SystemUserSimple} from '../models/system-user.model';
import {mapSearchListResponse} from '../helpers/search.helper';
import {SearchQueryParams} from '../models/search-query-params.model';
import {DictionaryItem} from '../models/dictionary.model';
import {ActiveProducts} from '../models/product.model';

@Injectable()
export class UserService {
    baseUrl = '/api/secured/users';

    constructor(
        private http: HttpClient
    ) {
    }

    fetchList(partnerId: number, props: SearchQueryParams, localizationId: number = null) {
        const params = new SearchQueryParams({
            filters: {
                partnerId,
                localizationId,
                ...props.filters,
            },
        });
        return this.http
            .get<SystemUser[]>(this.baseUrl, {params: params.getHttpParams(), observe: 'response'})
            .pipe(mapSearchListResponse<SystemUser>(SystemUser));
    }

    getById(userId: number) {
        return this.http.get<SystemUser>(`${this.baseUrl}/${userId}`);
    }

    add(user: SystemUser) {
        return this.http.post(this.baseUrl, {...user});
    }

    update(user: SystemUser) {
        return this.http.put(`${this.baseUrl}/${user.id}`, {...user});
    }

    activate(userId: number) {
        return this.http.put(`${this.baseUrl}/${userId}/activate`, {});
    }

    deactivate(userId: number) {
        return this.http.put(`${this.baseUrl}/${userId}/deactivate`, {});
    }

    passReset(userId: number) {
        return this.http.put(`${this.baseUrl}/${userId}/reset-password`, {});
    }

    getRoleFieldList(partnerId) {
        return this.http.get<DictionaryItem[]>(`${this.baseUrl}/available-roles/${partnerId}`);
    }

    passwordChange(formData) {
        return this.http.post('/api/secured/user/change-password', formData);
    }

    getSellerList() {
        return this.http.get<SystemUserSimple[]>(`${this.baseUrl}/sellers`);
    }

    getActiveProducts() {
        return this.http.get<ActiveProducts>('/api/secured/user/active-products');
    }
}
